"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const PaginationResultsBlock_1 = __importDefault(require("@Components/PaginationResultsBlock"));
const get_num_titles_1 = require("@App/helpers/pagination/get-num-titles");
const SuggestedMatchMetadata_1 = __importDefault(require("@Components/MatchComponents/v2/SuggestedMatchMetadata"));
const PaginationAndLimit_1 = __importDefault(require("@Components/PaginationAndLimit"));
const RecordingGroupGrid_1 = __importDefault(require("@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryRecordingGroups/RecordingGroupGrid"));
const recording_group_category_1 = __importDefault(require("@App/enum/recording-group-category"));
const lodash_1 = require("lodash");
const enum_from_value_1 = __importDefault(require("@App/helpers/enum-from-value"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const BackButton_1 = __importDefault(require("@Components/Buttons/BackButton"));
const react_router_dom_1 = require("react-router-dom");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const MatchHistoryRecordingGroups = (0, mobx_react_1.observer)(() => {
    var _a;
    const params = (0, react_router_dom_1.useParams)();
    const { matchHistoryStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    let foundStatus;
    try {
        foundStatus = (0, enum_from_value_1.default)((_a = params.recordingGroupCategory) !== null && _a !== void 0 ? _a : '', recording_group_category_1.default);
    }
    catch (_b) {
        throw new Error('Invalid Recording Group Status ' + params.recordingGroupCategory);
    }
    if (!params.submissionId) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const suggestionId = parseInt(params.submissionId, 10);
    const foundSelectedMatch = matchHistoryStore.selectedMatch;
    const foundData = matchHistoryStore.recordingGroupsDetails[foundStatus];
    const totalRecordingGroups = foundData ? foundData.totalElements : 0;
    const paginationData = matchHistoryStore.recordingGroupsDetailsPagination[foundStatus];
    const numTitles = paginationData &&
        (0, get_num_titles_1.getNumTitles)(totalRecordingGroups, paginationData.currentPage, matchHistoryStore.recordingGroupsResultsLimit);
    (0, react_1.useEffect)(() => {
        if (matchHistoryStore.selectedMatch && matchHistoryStore.selectedMatch.suggestedMatchId !== suggestionId) {
            matchHistoryStore.resetSelectedMatch();
        }
        if (!matchHistoryStore.selectedMatch) {
            preloaderStore.openTransparentPreloader(true);
            matchHistoryStore
                .loadSuggestedMatch(suggestionId)
                .then(() => matchHistoryStore.loadRecordingGroupDetails(suggestionId, foundStatus, {
                limit: matchHistoryStore.recordingGroupsResultsLimit,
                page: 1,
            }))
                .finally(() => preloaderStore.openTransparentPreloader(false));
        }
    }, []);
    const getRecordingGroupDetails = (pagination) => {
        setLoading(true);
        const paginationBody = pagination
            ? pagination
            : { limit: matchHistoryStore.recordingGroupsResultsLimit, page: 1 };
        matchHistoryStore.loadRecordingGroupDetails(suggestionId, foundStatus, paginationBody).finally(() => {
            setLoading(false);
        });
    };
    const changeResultLimit = (newLimit) => {
        matchHistoryStore.setRecordingGroupResultsLimit(newLimit);
        getRecordingGroupDetails();
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('match_history_recording_groups');
    }, []);
    return (react_1.default.createElement("div", { className: "match-recording-groups-wrapper" },
        react_1.default.createElement("section", { className: 'match-recording-group-head' },
            react_1.default.createElement(ContentHeader_1.default, { title: 'Match History', subTitle: 'View Submission', navLeft: react_1.default.createElement(BackButton_1.default, null), descriptionElement: 'All recording data featured below has been provided to ' +
                    'The MLC by the digital service provider (DSP) listed. ' +
                    'The MLC does not have the ability to edit or change any of ' +
                    'the information provided and does not assume responsibility ' +
                    'for accuracy' })),
        react_1.default.createElement("h2", { className: 'recording-group-type' },
            (0, lodash_1.capitalize)(foundStatus),
            " Recording Groups"),
        foundSelectedMatch && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: 'song-title' },
                react_1.default.createElement("span", null, "Song Title:"),
                react_1.default.createElement("strong", null, foundSelectedMatch.workTitle)),
            react_1.default.createElement(SuggestedMatchMetadata_1.default, { suggestedMatch: foundSelectedMatch }),
            react_1.default.createElement("section", { className: 'recording-groups-table' }, loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(PaginationResultsBlock_1.default, { totalResults: totalRecordingGroups, hideNoResults: true, workNumTitles: numTitles }),
                react_1.default.createElement(RecordingGroupGrid_1.default, { foundStatus: foundStatus })))),
            react_1.default.createElement(PaginationAndLimit_1.default, { paginationInfo: paginationData, onPageChange: getRecordingGroupDetails, onLimitChange: changeResultLimit, count: totalRecordingGroups, limit: matchHistoryStore.recordingGroupsResultsLimit })))));
});
exports.default = MatchHistoryRecordingGroups;
